<div class="card card-redlaboral m-4">
    <div class="card-body">
        <div class="row">
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                <h4 class="mt-0 mb-0 text-primary">
                    <i class="fa-solid fa-boxes-stacked"></i>
                    Catálogo Servicos/Productos
                </h4>
            </div>
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-end">
                <button type="button" class="btn btn-success" (click)="openAddItemModal()">
                    <i class="fa-solid fa-plus"></i>
                    Nuevo Servico/Producto
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Buscar ítem</label>
                    <div>
                        <input type="text" class="form-control" [(ngModel)]="filter.filterValue"
                            placeholder="Tipo o servicio" />
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="mt-button">
                    <button type="button" class="btn btn-primary" (click)="onSearch()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        Buscar
                    </button>
                    <a href="javascript:void(0);" class="text-decoration-none mx-1" (click)="showFilter()">
                        <i class="fa-solid fa-filter"></i>
                        Más filtros
                    </a>
                </div>
            </div>
        </div>

        @if (showFilters) {
        <div class="card mb-2">
            <div class="card-body">
                <div class="row">
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="form-group mb-3">
                            <label>Filtrar por</label>
                            <div>
                                <select class="form-control" [(ngModel)]="filter.filterKey">
                                    <option value="">Seleccione un filtro</option>
                                    <option value="fnctionalType">Tipo</option>
                                    <option value="availableServiceName">Servicio</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div class="mt-button">
                            <button type="button" class="btn btn-primary" (click)="onSearch()">
                                <i class="fa-solid fa-magnifying-glass"></i>
                                Aplicar filtros
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }

        @if (isLoading) {
        <div class="d-flex justify-content-center my-4">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
        </div>
        }

        @if (!isLoading) {
        <hr class="mt-3 mb-3" />
        <div class="table-responsive">
            <table class="table table-theme">
                <thead>
                    <tr>
                        <th class="text-start">ID</th>
                        <th class="text-start">Tipo</th>
                        <th class="text-start">Servicio</th>
                        <th class="text-center">Versión publicada</th>
                        <th class="text-start">Creado por</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center" width="230px">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @if (items.length === 0) {
                    <tr>
                        <td colspan="7" class="text-center py-4">
                            <i class="fa-solid fa-info-circle me-2"></i>
                            No se encontraron ítems con los criterios de búsqueda.
                        </td>
                    </tr>
                    }
                    @for (it of items; track it.id) {
                    <tr>
                        <td class="text-start">
                            <span class="badge rounded-pill text-bg-secondary">{{ it.id }}</span>
                        </td>
                        <td class="text-start">
                            <div class="d-flex align-items-center gap-2">
                                <span class="badge rounded-pill text-bg-primary">{{ it.functionalTypeName }}</span>
                            </div>
                        </td>
                        <td class="text-start">
                            {{ it.availableServiceName || 'N/A' }}
                        </td>
                        <td class="text-center">
                            <span class="badge rounded-pill"
                                [ngClass]="it.publishedVersionId ? 'text-bg-success' : 'text-bg-warning'">
                                {{ it.publishedVersionId ? ('#' + it.publishedVersionNumber) : 'Sin publicar' }}
                            </span>
                        </td>
                        <td class="text-start">
                            {{ it.createdByName || '—' }}
                            <div class="small text-muted">{{ it.createdAt | date:'dd/MM/yyyy hh:mm a' }}</div>
                        </td>
                        <td class="text-center">
                            <span class="badge rounded-pill"
                                [ngClass]="it.isDeleted ? 'text-bg-danger' : 'text-bg-success'">
                                {{ it.isDeleted ? 'Eliminado' : 'Activo' }}
                            </span>
                        </td>
                        <td class="text-center">
                            <button type="button" class="btn btn-sm btn-primary me-1" title="Ver versiones"
                                (click)="viewVersions(it)">
                                <i class="fa-solid fa-layer-group"></i>
                            </button>
                            @if(it.publishedVersionId){
                            <button type="button" class="btn btn-sm btn-warning me-1" title="Duplicar"
                                (click)="openDuplicateModal(it)">
                                <i class="fa-solid fa-clone"></i>
                            </button>
                            }
                            <button type="button" class="btn btn-sm btn-danger" title="Eliminar"
                                (click)="deleteItem(it.id)">
                                <i class="fa-solid fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

        @if (items.length > 0) {
        <app-pagination [page]="filter.page" [pageSize]="filter.pageSize" [totalItems]="totalItems"
            (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
        </app-pagination>
        }
        }
    </div>
</div>

<app-modal-catalog-wizard (changeData)="load()"/>
<app-modal-catalog-versions (changeData)="load()"/>
<app-modal-duplicate-catalog-version (changeData)="load()"/>